import * as React from 'react';

import { useDispatch } from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';
import { IAppPropsWithRoute } from '../../common/types';
import ResetPassword from './ResetPassword'
import ResetPasswordSubmitted from './ResetPasswordSubmitted'
import ResetPasswordConfirmed from './ResetPasswordConfirmed'
import { withRouter } from 'react-router-dom';
import { useState } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import useWindowSize from '../shared/useWindowSize';
import { isItTablet1280x800inLandscape } from '../../common/helpers';
import ResetPasswordWidgetForTablets from './loginForMobile/ResetPasswordWidgetForTablets';
import ResetPasswordSubmittedForTablets from './loginForMobile/ResetPasswordSubmittedForTablets';
import ResetPasswordConfirmedForTablets from './loginForMobile/ResetPasswordConfirmedForTablets';

interface ResetPasswordPageProps extends IAppPropsWithRoute {
};


const useStyles = makeStyles((theme: Theme) => ({

}));

function ResetPasswordPage(props: ResetPasswordPageProps): JSX.Element {
    const dispatch = useDispatch();
    const { windowWidth } = useWindowSize();
    const requestId = props.match.params.requestId;
    const [resetPasswordStep, setResetPasswordStep] = useState(0)
    const [emailAddress, setEmailAddress] = useState('')
    React.useEffect(() => {
        dispatch(showNavbar(false));
    }, [])

    const completeResetPassword = (emailAddress: string) => {
        setEmailAddress(emailAddress);
        setResetPasswordStep(1)
    }

    const completeResetPasswordConfirmed = () => {

    }

    const renderChild = () => {
        if (requestId === null || requestId === undefined || requestId === '') {
            return (resetPasswordStep == 0) ? <ResetPassword completeResetPassword={completeResetPassword} /> : <ResetPasswordSubmitted emailAddress={emailAddress} />
        }
        else {
            return (resetPasswordStep == 0) ? <ResetPasswordConfirmed completeResetPassword={completeResetPasswordConfirmed} requestId={requestId} /> : <ResetPasswordSubmitted emailAddress={emailAddress} />
        }
    }

    const renderTabletChild = () => {
        if (requestId === null || requestId === undefined || requestId === '') {
            return (resetPasswordStep == 0) ? <ResetPasswordWidgetForTablets completeResetPassword={completeResetPassword} /> : <ResetPasswordSubmittedForTablets />
        }
        else {
            return (resetPasswordStep == 0) ? <ResetPasswordConfirmedForTablets completeResetPassword={completeResetPasswordConfirmed} requestId={requestId} /> : <ResetPasswordSubmittedForTablets />
        }
    }

    return (
        <React.Fragment>
            {isItTablet1280x800inLandscape(windowWidth) ? renderTabletChild() : renderChild()}
        </React.Fragment>
    );
}

export default React.memo(withRouter(ResetPasswordPage)) 
